import { environment } from '@env/environment';
import { Image } from './image.model';
import { BaseModel } from './base.model';

export interface ApplicationTypeMap {
  residential: string;
  business: string;
  parking: string;
  storage: string;
}

export class Building extends BaseModel {
  static APPLICATION_TYPE_INTERNAL = 'internal';
  static APPLICATION_TYPE_EXTERNAL = 'external';

  id!: number;
  instanceId!: number;

  propertyId!: string;
  applicationType!: ApplicationTypeMap;
  title?: string;
  teaser?: string;
  private _address?: string;
  street?: string;
  streetNumber?: string;
  zip?: string;
  city?: string;
  description?: string;
  coverImageId?: number;
  totalArea?: number;
  totalBusinessArea?: number;
  totalApartmentArea?: number;
  totalUnits?: number;
  totalBusinessUnits?: number;
  totalApartmentUnits?: number;
  minRentMonths?: number;
  depositMultiplier?: number;
  noticePeriod?: string;
  auxiliaryCost?: number;
  completion?: string;

  externalSource?: string | null;
  externalId?: string | null;
  syncedFields?: string[];

  images?: Image[];
  coverImage?: Image;

  createdBy?: number;
  updatedBy?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;

  set address(value: string | undefined) {
    this._address = value;
  }

  get address(): string {
    const parts = [this.street, this.streetNumber].filter(Boolean).join(' ');
    const cityPart = [this.zip, this.city].filter(Boolean).join(' ');
    const structured = [parts, cityPart].filter(Boolean).join(', ');
    return structured || this._address || '';
  }

  get isManagedBySync(): boolean {
    return !!this.syncedFields?.length;
  }

  get childModels() {
    return {
      images: Image,
      coverImage: Image,
    };
  }

  get coverImageUrl(): string | null {
    if (!this.coverImageId) {
      return null;
    }

    return `${environment.apiBaseUrl}/${this.instanceId}/images/${this.coverImageId}`;
  }
}
